"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatNodes = void 0;
var lodash_1 = require("lodash");
var flatNodes = function (mem) {
    var member = __assign({}, mem); // copy
    delete member.children;
    if (!mem.children || !mem.children.length) {
        return member; // return copied
    }
    return [member, lodash_1.flatMapDeep(mem.children, exports.flatNodes)]; // return copied, but pass original to flatMapDeep
};
exports.flatNodes = flatNodes;
